export const appendHtml = (html = '', value: string | number) => {
  const pattern = /<\/p>(?![\s\S]*<\/p>)/;
  const newHtml = html.replace(pattern, `{{${value}}}</p>`);
  return newHtml;
};

export function appendContentVariable(
  content = '',
  value: string | number
): string {
  const token = `{{${value}}}`;
  if (/<\/p>/i.test(content)) {
    return appendHtml(content, value);
  }
  if (!content) return token;
  const needsSpace = !/\s$/.test(content);
  return needsSpace ? `${content} ${token}` : `${content}${token}`;
}
